<template>
  <div class="home">
    <!-- Banner（100%宽度） -->
    <section class="banner full-width" :style="`background-image: url(${bannerUrl});`">
        <div class="banner-box">
            <h1 class="banner-title">{{ $t('home.bannerTitle') }}</h1>
            <!-- <p>{{ $t('home.bannerSubtitle') }}</p> -->
            <span></span>
        </div>
    </section>

    <!-- 公司介绍 -->
    <div class="company">
        <div class="container flex">
            <div class="left">
                <div class="title">{{ $t('home.companyTitle') }}</div>
                <div class="line"></div>
                <div class="intro">{{ $t('home.companyIntro') }}</div>
                <div class="intro">{{ $t('home.companyIntro2') }}</div>
            </div>
            <div class="right"><img :src="company"></div>
        </div>
    </div>

    <!-- 企业文化 -->
    <div class="culture" :style="`background-image: url(${culture});`">
        <div class="container flex" style="justify-content: center;">
            <div>
                <div class="title">{{ $t('home.culture') }}</div>
                <div class="line"></div>
                <div class="culture-list flex" :class="{ 'culture-list--vertical': isLatinLocale }">
                    <div class="culture-item flex" style="justify-content:flex-start;">
                        <div class="left">
                            <div class="title">{{ $t('home.mission') }}</div>
                            <div class="info">{{ $t('home.missionInfo') }}</div>
                        </div>
                        <div class="right"><img :src="icon_mission"></div>
                    </div>
                    <div class="culture-item flex" style="justify-content:flex-start;">
                        <div class="left">
                            <div class="title">{{ $t('home.vision') }}</div>
                            <div class="info">{{ $t('home.visionInfo') }}</div>
                        </div>
                        <div class="right"><img :src="icon__vision"></div>
                    </div>
                    <div class="culture-item flex" style="justify-content:flex-start;">
                        <div class="left">
                            <div class="title">{{ $t('home.value') }}</div>
                            <div class="info">{{ $t('home.valueInfo') }}</div>
                        </div>
                        <div class="right"><img :src="icon_value"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section class="product-section full-width">
        <div class="container">
            <div class="product-header">
                <h2 class="section-title">{{ $t('home.productTitle') }}</h2>
                <span @click="$router.push('/productCenter')" class="view-all-btn">{{ $t('home.viewAll') }}</span>
            </div>
        </div>
        <div class="product-wrap">
            <div class="arrow product-left swiper-button-prev"></div>
            <div class="product-wrap-main">
              <swiper ref="mySwiper" class="product" :options="swiperOptions1">
                <swiper-slide v-for="(item, index) in slideList" :key="index">
                  <div class="item">
                      <img :src="item.imgUrl">
                      <div class="content">
                        <h3>{{ item.title }}</h3>
                        <span>{{ item.content }}</span>
                        <div class="more">
                          {{ $t('home.moreInfo') }}
                          <i class="el-icon-arrow-right"></i>
                        </div>
                      </div>
                  </div>
                </swiper-slide>
              </swiper>
              <div class="swiper-pagination swiper-pagination1"></div>
            </div>
            <div class="arrow product-right swiper-button-next"></div>
        </div>
    </section>

    <div class="solution">
        <div class="container flex">
            <div class="left">
                <div class="title">{{ $t('home.solutionTitle') }}</div>
                <div class="line"></div>
            </div>
        </div>
    </div>

    <div class="solution-image-wrap">
        <div class="masonry">
            <div class="grid-item-1" @click="toPage('/marketArea/spaceflight', 650)">
                <img :src="solution1">
                <div class="grid-item-content"><h3>{{ $t('home.solutions.spaceflight') }}</h3></div>
            </div>
            <div class="grid-item-2" @click="toPage('/marketArea/chemicalEngineering', 650)">
                <img :src="solution2">
                <div class="grid-item-content"><h3>{{ $t('home.solutions.chemical') }}</h3></div>
            </div>
            <div class="grid-item-3" @click="toPage('/marketArea/electron', 650)">
                <img :src="solution3">
                <div class="grid-item-content"><h3>{{ $t('home.solutions.electron') }}</h3></div>
            </div>
            <div class="grid-item-4" @click="toPage('/marketArea/transportation', 650)">
                <img :src="solution4">
                <div class="grid-item-content"><h3>{{ $t('home.solutions.transportation') }}</h3></div>
            </div>
            <div class="grid-item-5" @click="toPage('/marketArea/newEnergy', 650)">
                <img :src="solution5">
                <div class="grid-item-content"><h3>{{ $t('home.solutions.newEnergy') }}</h3></div>
            </div>
            <div class="grid-item-6" @click="toPage('/marketArea/AI', 650)">
                <img :src="solution6">
                <div class="grid-item-content"><h3>{{ $t('home.solutions.AI') }}</h3></div>
            </div>
            <div class="grid-item-7" @click="toPage('/marketArea/architecture', 650)">
                <img :src="solution7">
                <div class="grid-item-content"><h3>{{ $t('home.solutions.architecture') }}</h3></div>
            </div>
            <div class="grid-item-8" @click="toPage('/marketArea/homeAppliances', 650)">
                <img :src="solution8">
                <div class="grid-item-content"><h3>{{ $t('home.solutions.homeAppliances') }}</h3></div>
            </div>
        </div>
    </div>

    <div class="news">
        <div class="container">
            <div class="left">
                <div class="title">{{ $t('home.newsTitle') }}</div>
                <div class="line"></div>
            </div>
        </div>
        <div class="article-wrap">
            <div class="arrow arrow-left swiper-button-prev"></div>
            <div class="article-wrap-main">
              <swiper ref="mySwiper" class="article" :options="swiperOptions2">
                <swiper-slide v-for="(item, index) in articleList" :key="index">
                  <div class="item" :style="`background-image: url(${shadow});`">
                      <div class="date">{{ item.createDate }}</div>
                      <div class="title">{{ item.content }}</div>
                  </div>
                </swiper-slide>
              </swiper>
              <div class="swiper-pagination swiper-pagination2"></div>
            </div>
            <div class="arrow arrow-right swiper-button-next"></div>
        </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
    data () {
        return {
            bannerUrl: require('@/assets/images/banner.png'),
            left: require('@/assets/images/left.png'),
            right: require('@/assets/images/right.png'),
            company: require('@/assets/images/company.png'),
            culture: require('@/assets/images/culture.png'),
            icon_mission: require('@/assets/images/icon_mission@2x.png'),
            icon__vision: require('@/assets/images/icon__vision@2x.png'),
            icon_value: require('@/assets/images/icon_value@2x.png'),
            solution1: require('@/assets/images/solution/1.png'),
            solution2: require('@/assets/images/solution/2.png'),
            solution3: require('@/assets/images/solution/3.png'),
            solution4: require('@/assets/images/solution/4.png'),
            solution5: require('@/assets/images/solution/5.png'),
            solution6: require('@/assets/images/solution/6.png'),
            solution7: require('@/assets/images/solution/7.png'),
            solution8: require('@/assets/images/solution/8.png'),
            shadow: require('@/assets/images/shadow.png'),
            swiperOptions1: {
                allowTouchMove: false,
                slidesPerView: 3,      // 一屏显示 3 个 slide
                slidesPerGroup: 1,     // 每次滑动 1 个 slide（关键）
                spaceBetween: 20,      // slide 间距
                loop: true,           // 是否循环
                autoplay: true,
                autoplayDisableOnInteraction: false, // 用户交互后不停止
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                // 可选：分页器
                pagination: {
                    el: '.swiper-pagination1',
                    clickable: true
                }
            },
            swiperOptions2: {
                allowTouchMove: false,
                slidesPerView: 3,      // 一屏显示 3 个 slide
                slidesPerGroup: 1,     // 每次滑动 1 个 slide（关键）
                spaceBetween: 20,      // slide 间距
                loop: true,           // 是否循环
                autoplay: true,
                autoplayDisableOnInteraction: false, // 用户交互后不停止
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                // 可选：分页器
                pagination: {
                    el: '.swiper-pagination2',
                    clickable: true
                }
            },


        }
    },
    computed: {
        isLatinLocale () {
            return ['en', 'de'].includes(this.$i18n.locale)
        },
        slideList () {
        return [
        {
        title: this.$t('home.products.fireproof.title'),
        content: this.$t('home.products.fireproof.content'),
        imgUrl: require('@/assets/images2/cp/7.png'),
        },
        {
        title: this.$t('home.products.thermalInsulation.title'),
        content: this.$t('home.products.thermalInsulation.content'),
        imgUrl: require('@/assets/images2/cp/8.png'),
        },
        {
        title: this.$t('home.products.dielectricCoating.title'),
        content: this.$t('home.products.dielectricCoating.content'),
        imgUrl: require('@/assets/images2/cp/9.png'),
        },
        {
        title: this.$t('home.products.heatConduction.title'),
        content: this.$t('home.products.heatConduction.content'),
        imgUrl: require('@/assets/images2/cp/2.png'),
        },
        {
        title: this.$t('home.products.nanoBoard.title'),
        content: this.$t('home.products.nanoBoard.content'),
        imgUrl: require('@/assets/images2/cp/4.png'),
        },
        {
        title: this.$t('home.products.electricConduction.title'),
        content: this.$t('home.products.electricConduction.content'),
        imgUrl: require('@/assets/images2/cp/1.png'),
        },
        {
        title: this.$t('home.products.electricHeating.title'),
        content: this.$t('home.products.electricHeating.content'),
        imgUrl: require('@/assets/images2/cp/3.png'),
        },
        {
        title: this.$t('home.products.heatInsulation.title'),
        content: this.$t('home.products.heatInsulation.content'),
        imgUrl: require('@/assets/images2/cp/5.png'),
        },
        {
        title: this.$t('home.products.dielectric.title'),
        content: this.$t('home.products.dielectric.content'),
        imgUrl: require('@/assets/images2/cp/6.png'),
        },
        ]
        },
        articleList () {
        return [
        { createDate: '2025-03', content: this.$t('home.news.article1') },
        { createDate: '2025-04', content: this.$t('home.news.article2') },
        { createDate: '2025-05', content: this.$t('home.news.article3') },
        { createDate: '2025-06', content: this.$t('home.news.article2') },
        { createDate: '2025-08', content: this.$t('home.news.article3') },

        ]
        },
    },
  mounted() {
    this.$nextTick(() => {
      let self = this
      const btn = document.querySelectorAll('.more');
      btn.forEach(item => {
        // 监听点击事件
        item.addEventListener('click', () => {
          self.productMore()
        })
      })
      
    })

  },
  methods: {
    productMore () {
        this.$router.push('/productCenter')
    },
    toPage (path, position) {
        document.querySelector('body').scroll(0, position)
        this.$router.push(path)
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
}
</script>

<style scoped lang="scss">
.home {
  /* Banner区域（严格匹配设计图） */
  .banner {
      height: 968px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
      position: relative;
  }

  .banner-box {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 1300px;
      background: rgba(255, 255, 255, 0.2);
      padding: 80px;
      border: 1px solid #fff;

      p {
        font-size: 34px;
        line-height: 30px;
        color: #fff;
        margin-top: 10px;
      }

      span {
        width: 100px;
        height: 4px;
        background: #FFFFFF;
        display: block;
        margin-top: 40px;
      }
  }

  .banner-title {
      font-size: 60px;
      color: #fff;
      line-height: 66px;
      font-weight: 600;
  }
  .search-wrap {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 100%;
  }

  .search-input {
      width: 860px;
      height: 56px;
      padding: 0 15px;
      /* border: 1px solid #ddd; */
      border-left: none;
      border-right: none;
      border-top: none;
      border-bottom: 2px solid rgba(255, 255, 255, 0.2);
      background: none;
      outline: none;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
  }
  .search-input::placeholder {
      color: rgba(255, 255, 255, 0.7);
  }


  .search-btn {
      width: 220px;
      height: 56px;
      background-color: #0078d7;
      color: #fff;
      border: none;
      cursor: pointer;
      font-size: 18px;
  }

  .product-section{
      padding: 60px 0;
  }

  .product-header {
      width: 1200px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      margin: 0 auto;
      padding-bottom: 40px;
      a {
        text-decoration: none;
      }
  }

  .view-all-btn {
      background-color: #1c64d7;
      color: #fff;
      padding: 5px 20px;
      font-size: 14px;
      cursor: pointer;
  }


  .product-wrap {
      margin: 0 auto;
      width: 1400px;
      position: relative;
      overflow: hidden;
  }

  .product-wrap-main {
      margin: 0 auto;
      width: 1200px;
      height: 550px;
      position: relative;
      overflow: hidden;
  }

  .product-wrap .product {
      height: 520px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: transform 0.5s ease;
      /* 平滑滚动动画 */
  }

  .product-wrap .item {
    position: relative;
      width: 380px;
      height: 480px;
      flex-shrink: 0;
      transform: scale(0.92);
      transition: all .3s ease-in-out;
  }
  .product-wrap .item h3 {
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    padding-bottom: 12px;
  }
  .product-wrap .item .content {
    position: absolute;
    bottom: 0;
    backdrop-filter: blur(20px);
    background: rgba(34, 34, 34, 0.5);
    padding: 16px 20px;
    color: #fff;
    span {
      height: 88px;
      line-height: 22px;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: rgba(255,255,255, .8);
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;    /* 限制显示4行 */
      overflow: hidden;
      word-break: break-word;    /* 防止长单词溢出 */
    }
    .more {
      padding-top: 20px;
      text-align: right;
      cursor: pointer;
      i {
        padding-left: 12px;
        
      }
    }
  }
  .swiper-pagination {
    left: 50%;
    transform: translateX(-50%);
    ::v-deep span {
        margin: 0 3px;
        cursor: pointer;
    }
  }
  .product-wrap .item img{
      width: 380px;
      height: 480px;
      cursor: pointer;
  }
  ::v-deep .swiper-slide {
    display: flex;
    align-items: center;
  }
  ::v-deep .product .swiper-slide.swiper-slide-next .item {
    transform: scale(1.05);
  }
  ::v-deep .swiper-slide.swiper-slide-next .item .content {
    background-color: rgb(28, 100, 215);
    bottom: 0;
  }
  .product-wrap .arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 40px;
      height: 40px;
      cursor: pointer;
      z-index: 10;
      user-select: none;
  }
  .product-wrap .arrow img{
      width: 40px;
      height: 40px;
  }
  .product-wrap .product-left {
      left: 20px;
      color: #666;
  }
  .product-wrap .product-right {
      right: 20px;
      color: #666;
  }
  
  /* 公司介绍区域 */
  .company {
      width: 100%;
      height: 510px;
      background: rgba(248, 250, 253, 1);
  }

  .company .left {
      width: 660px;
      height: auto;
  }

  .company .left .title {
      font-weight: 600;
      font-size: 36px;
      line-height: 50px;
      color: rgba(43, 50, 71, 1);
  }

  .company .left .line {
      margin: 16px 0 24px 0;
      width: 80px;
      height: 4px;
      background: rgba(28, 100, 215, 1);
  }

  .company .left .intro {
      font-size: 16px;
      line-height: 22px;
      color: rgba(43, 50, 71, 0.7);
  }

  .company .right {
      width: 488px;
      height: 278px;
  }

  .company .right img {
      width: 488px;
      height: 278px;
      object-fit: cover;
  }
  .company .container {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      position: relative;
  }

  .flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
  }

  .container {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    position: relative;
  }

  .culture {
      width: 100%;
      height: 600px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;
      position: relative;
  }

  .culture .title {
      font-weight: 500;
      font-size: 36px;
      line-height: 50px;
      color: rgba(255, 255, 255, 1);
      text-align: center;
  }

  .culture .line {
      width: 80px;
      height: 4px;
      background: rgba(224, 234, 242, 1);
      margin: 16px auto 80px;
  }

  .culture .culture-list {
      height: 168px;
      width: 1200px;
  }

  .culture .culture-item {
      width: 373.3px;
      height: 168px;
      border-radius: 4px;
      background: rgba(255, 255, 255, 1);
  }

  .culture .culture-item .left {
      margin-left: 48px;
      width: 215.3px;
  }

  .culture .culture-item .left .title {
      text-align: left;
      color: rgba(43, 50, 71, 1);
      font-weight: 700;
      font-size: 24px;
      line-height: 30px;
  }

  .culture .culture-item .left .info {
      margin-top: 14px;
      color: rgba(43, 50, 71, 0.7);
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      width: 179.3px;
  }

  .culture .culture-item .right {
      width: 60px;
      height: 60px;
  }

  .culture .culture-item .right img {
      width: 60px;
      height: 60px;
  }

  /* 英文/德文：图标居中在上，标题、简介依次居中排列 */
  .culture .culture-list--vertical {
      justify-content: space-between;
      gap: 40px;
  }

  .culture .culture-list--vertical .culture-item {
      flex: 1;
      flex-direction: column;
      justify-content: center !important;
      align-items: center;
      padding: 24px 20px;
      height: auto;
      min-height: 168px;
  }

  .culture .culture-list--vertical .culture-item .right {
      order: 1;
      margin-bottom: 16px;
  }

  .culture .culture-list--vertical .culture-item .left {
      order: 2;
      margin-left: 0;
      width: 100%;
      text-align: center;
  }

  .culture .culture-list--vertical .culture-item .left .title {
      text-align: center;
  }

  .culture .culture-list--vertical .culture-item .left .info {
      width: 100%;
      text-align: center;
  }

  .solution {
      width: 100%;
      height: 190px;
      background: #fff;
      position: relative;
  }

  .solution .left {
      width: 660px;
      height: auto;
  }

  .solution .left .title {
      font-weight: 600;
      font-size: 36px;
      line-height: 50px;
      color: rgba(43, 50, 71, 1);
  }

  .solution .left .line {
      margin: 16px 0 24px 0;
      width: 80px;
      height: 4px;
      background: rgba(28, 100, 215, 1);
  }

  .solution-image-wrap {
      width: 100%;
      height: auto;
      position: relative;
  }

  .solution-image-wrap .masonry {
      width: 1920px;
      height: 100%;
      margin: 0 auto;
      position: relative;
      /* display: flex;
      flex-wrap: wrap; */
  }

  .solution-image-wrap .masonry div {
      float: left;
  }

  .grid-item-1, .grid-item-2, .grid-item-3, .grid-item-4,
  .grid-item-5, .grid-item-6, .grid-item-7, .grid-item-8 {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    &:hover {
        .grid-item-content {
            opacity: 1;
        }
        img {
            transform: scale(1.2);
        }
    }
    img {
        transition: all .3s ease-in-out;
    }
    .grid-item-content {
        transition: all .3s ease-in-out;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        color: #fff;
        background-color: rgba(0,0,0,0.5);
        font-size: 56px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        h3 {
            display: inline-block;
            position: relative;
            &::after {
                content: '';
                position: absolute;
                left: 0;
                bottom: 0;
                display: inline-block;
                width: 100%;
                height: 3px;
                background-color: #fff;
            }
        }
    }
  }
  .grid-item-1 {
    position: relative;
    width: 669px;
    height: 960px;
  }

  .grid-item-1 img {
      width: 669px;
      height: 960px;
  }

  .grid-item-2 {
      width: 770px;
      height: 480px;
  }

  .grid-item-2 img {
      width: 770px;
      height: 480px;
  }

  .grid-item-3 {
      width: 481px;
      height: 480px;
  }

  .grid-item-3 img {
      width: 481px;
      height: 480px;
  }

  .grid-item-4 {
      width: 480px;
      height: 480px;
  }

  .grid-item-4 img {
      width: 480px;
      height: 480px;
  }

  .grid-item-5 {
      width: 771px;
      height: 480px;
  }

  .grid-item-5 img {
      width: 771px;
      height: 480px;
  }

  .grid-item-6 {
      width: 670px;
      height: 480px;
  }

  .grid-item-6 img {
      width: 670px;
      height: 480px;
  }

  .grid-item-7 {
      width: 768px;
      height: 480px;
  }

  .grid-item-7 img {
      width: 768px;
      height: 480px;
  }

  .grid-item-8 {
      width: 482px;
      height: 480px;
  }

  .grid-item-8 img {
      width: 482px;
      height: 480px;
  }

  .news {
      clear: both;
      width: 100%;
      padding-bottom: 148px;
      background: rgba(255, 255, 255, 1);
  }

  .news .left {
      width: 660px;
      height: auto;
  }

  .news .left .title {
      padding-top: 80px;
      font-weight: 600;
      font-size: 36px;
      line-height: 50px;
      color: rgba(43, 50, 71, 1);
  }

  .news .left .line {
      margin: 16px 0 40px 0;
      width: 80px;
      height: 4px;
      background: rgba(28, 100, 215, 1);
  }

  .news .article-wrap {
      margin: 0 auto;
      width: 1400px;
      position: relative;
      overflow: hidden;
  }

  .news .article-wrap-main {
      margin: 0 auto;
      width: 1260px;
      height: 280px;
      position: relative;
      overflow: hidden;
  }

  .news .article {
      height: 246px;
      display: flex;
      align-items: center;
      transition: transform 0.5s ease;
      /* 平滑滚动动画 */
  }

  .news .article .item {
      width: 420px;
      height: 246px;
      flex-shrink: 0;
      background-repeat: no-repeat;
      background-size: cover;

  }

  .news .article .item .date {
      margin: 50px 20px 0 40px;
      color: rgba(43, 52, 64, 1);
      font-size: 20px;
      line-height: 30px;
  }

  .news .article .item .title {
      margin: 16px 40px 0 40px;
      color: rgba(43, 52, 64, 1);
      font-size: 22px;
      line-height: 31px;
  }

  .news .arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 40px;
      height: 40px;
      cursor: pointer;
      z-index: 10;
      user-select: none;
      color: #666;
  }
  .news .arrow img{
      width: 40px;
      height: 40px;
  }
  .news .arrow-left {
      left: 0;
  }
  .news .arrow-right {
      right: 0;
  }
}
</style>